module.exports = __webpack_public_path__ + "assets/img/mali-template.60fd71d3.png";